module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJkAAAAGCAYAAADQbDwsAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAmaADAAQAAAABAAAABgAAAAAAz1zlAAAAnElEQVRIDWNkGAWjIUClENi/fz/Ls2fPev///9/Nxsb2PCws7C/IaCYqmT9qzGgIMLx+/RqUnnIZGRnX//nzJ2DhwoXCoGBhHA2b0RCgVgisWrWK7ffv3z+h5n0C0suApdoSFmpZMGrOaAighQAfkJ/OxMRkybJs2bJdaJKj3NEQICsEgKUYevOLEViS6bMACVeyTBzVNBoCRIYAAD74LRbzjS9GAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/v3/rjt.png
// module id = GCoU
// module chunks = 1